export const ASSET_GROUP_LIST = "ASSET_GROUP_LIST";
export const ASSET_GROUP_LIST_SUCCESS = "ASSET_GROUP_LIST_SUCCESS";
export const ASSET_GROUP_LIST_FAILURE = "ASSET_GROUP_LIST_FAILURE";

export const ASSET_GROUP_DATA = "ASSET_GROUP_DATA";
export const ASSET_GROUP_DATA_SUCCESS = "ASSET_GROUP_DATA_SUCCESS";
export const ASSET_GROUP_DATA_FAILURE = "ASSET_GROUP_DATA_FAILURE";

export const ASSET_GROUP_CREATE = "ASSET_GROUP_CREATE";
export const ASSET_GROUP_CREATE_SUCCESS = "ASSET_GROUP_CREATE_SUCCESS";
export const ASSET_GROUP_CREATE_FAILURE = "ASSET_GROUP_CREATE_FAILURE";

export const ASSET_GROUP_UPDATE = "ASSET_GROUP_UPDATE";
export const ASSET_GROUP_UPDATE_SUCCESS = "ASSET_GROUP_UPDATE_SUCCESS";
export const ASSET_GROUP_UPDATE_FAILURE = "ASSET_GROUP_UPDATE_FAILURE";

export const ASSET_GROUP_DELETE = "ASSET_GROUP_DELETE";
export const ASSET_GROUP_DELETE_SUCCESS = "ASSET_GROUP_DELETE_SUCCESS";
export const ASSET_GROUP_DELETE_FAILURE = "ASSET_GROUP_DELETE_FAILURE";
